import React, { useContext, useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonGroup, Headline, TextButton, Text } from '@oneaudi/unified-web-components';
import { vehicleContext } from '../VehicleProvider';
import { Container, PageMargin, ButtonsContainer, TextContainer } from './NoVehicle.styles';

const NoVehicle: React.FC = () => {
  const { loading, vehicle, market } = useContext(vehicleContext);
  const { t, i18n } = useTranslation();
  const lang = i18n.languages[0] || 'en';
  const locationSearch = typeof window !== 'undefined' ? window.location.search : '';
  const host = typeof window !== 'undefined' ? window.location.origin : '';
  const hrefPath = typeof window !== 'undefined' ? window.location.href : '';
  const isTier1 = useMemo(() => {
    if (host.includes('audiusa.com') || host.includes('audi.ca')) return true;
    return false;
  }, [host]);

  const path =
    hrefPath.split('/')[6] === 'test_pages'
      ? 'test_pages/vehicle-list-page.html'
      : 'inventory.html';

  const isTier3 = new URLSearchParams(locationSearch).has('isdealer') || !isTier1;
  // const isUsedVehicle = market.includes('uc');

  const createRedirectUrl = useCallback(
    (type: 'used' | 'new') => {
      return !isTier3
        ? `${host}/${market}/web/${lang}/${path}?type=${type}`
        : `${host}/en/inventory/${type}/`;
    },
    [host, isTier3, lang, market, path],
  );

  const usedRedirect = useMemo(() => createRedirectUrl('used'), [createRedirectUrl]);
  const newRedirect = useMemo(() => createRedirectUrl('new'), [createRedirectUrl]);

  if (loading || vehicle) return null;

  return (
    <PageMargin>
      <Container data-testid="no-vehicle-wrapper">
        <Headline
          tag="h3"
          variant={{
            type: 'headline',
            order: '3',
            weight: 'bold',
          }}
        >
          {t('noVehicle.title')}
        </Headline>
        <TextContainer>
          <Text>{t('noVehicle.copy')}</Text>
        </TextContainer>
        <ButtonsContainer>
          <ButtonGroup>
            <TextButton
              data-testid="no-vehicle-cta"
              href={newRedirect}
              size="md"
              variant="secondary"
            >
              {t('noVehicle.newCTA')}
            </TextButton>
            <TextButton
              data-testid="no-vehicle-cta-used"
              href={usedRedirect}
              size="md"
              variant="secondary"
            >
              {t('noVehicle.usedCTA')}
            </TextButton>
          </ButtonGroup>
        </ButtonsContainer>
      </Container>
    </PageMargin>
  );
};

export default NoVehicle;
